import * as React from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";

import { Move } from "../../types";

import { View, Text } from "../../components/Themed";
import commonStyles from "../../styles/common";
import useUpdateMove from "../../hooks/moves/useUpdateMove";

import MoveListItem, { MoveListItemProps } from "./MoveListItem";

import _ from "lodash";

export interface MoveListProps {
  style?: StyleProp<ViewStyle>;
  moves?: Move[];
  renderItem?: (props: MoveListItemProps) => JSX.Element;
  disabled?: boolean;
}

function MoveList({
  style,
  moves,
  renderItem: Item = MoveListItem,
  disabled,
}: MoveListProps) {
  const { mutate: updateMove } = useUpdateMove();
  const empty = !moves?.length;

  return (
    <View style={[style, commonStyles.grid]}>
      {moves?.map((move, index) => (
        <React.Fragment key={move.id}>
          <Item
            move={move}
            onSave={(values) => {
              // updateMove({ ...values, id: move.id });
            }}
            disabled={disabled}
          />
        </React.Fragment>
      ))}

      {empty && <Text>No Moves</Text>}
    </View>
  );
}

const styles = StyleSheet.create({});

export default MoveList;
